import React from 'react';
import PropTypes from 'prop-types';
import { labelTextReplace } from '../../helpers';
import AutoCompletePlayer from './AutoCompletePlayer';
import SelectStats from './SelectStats';
import TextField from 'material-ui/TextField';
import InputMaterial from '../../../../../front-v2/components/uiElements/forms/InputMaterial';

const PlayerPicker = ({
    id,
    params: {
        defaultName = '',
        type,
        playerId,
        selectValue = '',
        propsMap: { stats: statsMap, ...propsMap } = {},
        ...params
    } = {},
    fullWidth = true,
    updateWidgetJSPropField,
    isCustomInput = true,
}) => {
    if (id == null || type !== 'player') {
        return null;
    }

    const InputComponent = isCustomInput ? InputMaterial : TextField;
    console.log(playerId, 'playerId', statsMap);
    return (
        <div>
            <AutoCompletePlayer
                id={id}
                defaultName={defaultName}
                propsMap={propsMap}
                updateWidgetJSPropField={updateWidgetJSPropField}
            />
            {statsMap &&
                playerId && (
                    <SelectStats
                        id={id}
                        valueDefault={selectValue}
                        playerId={playerId}
                        propsStatsMap={statsMap}
                        updateWidgetJSPropField={updateWidgetJSPropField}
                    />
                )}
            {Object.entries({ ...propsMap, ...(statsMap || {}) }).map(([key = '']) => (
                <InputComponent
                    key={key}
                    floatingLabelText={labelTextReplace(key)}
                    value={params[key] == null ? '' : params[key]}
                    fullWidth={fullWidth}
                    onChange={(event, value) => {
                        updateWidgetJSPropField(id, { [key]: value });
                    }}
                />
            ))}
        </div>
    );
};

PlayerPicker.propTypes = {
    id: PropTypes.string,
    params: PropTypes.shape({
        name: PropTypes.string,
        score: PropTypes.string,
        placeholder: PropTypes.string,
    }),
    propsMap: PropTypes.objectOf(PropTypes.string),
    fullWidth: PropTypes.bool,
    isCustomInput: PropTypes.bool,
    updateWidgetJSPropField: PropTypes.func.isRequired,
};

export default PlayerPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/PlayerPicker/index.js
 **/